module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " padding-left-30 padding-right-30 padding-bottom-30"
  }, [_c('div', {
    staticClass: "vctb-list"
  }, [_c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 0
      }
    }
  }, [_vm._v("\n\t\t\t裁判文书(" + _vm._s(_vm.document_group.totalnum) + ")\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 1
      }
    }
  }, [_vm._v("\n\t\t\t法院公告(" + _vm._s(_vm.courtnotice_group.totalnum) + ")\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 2
      }
    }
  }, [_vm._v("\n\t\t\t开庭公告(" + _vm._s(_vm.opennotice_group.totalnum) + ")\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "vctb-item",
    class: {
      'vctb-item-active': _vm.vctbIndex == 3
    },
    on: {
      "click": function($event) {
        _vm.vctbIndex = 3
      }
    }
  }, [_vm._v("\n\t\t\t立案信息(" + _vm._s(_vm.filing_group.totalnum) + ")\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left-10 padding-right-10 "
  }, [(_vm.vctbIndex == 0) ? [_vm._m(0), _vm._v(" "), _vm._l((_vm.document_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.title || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.caseCause || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.plaintiffs || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.defendants || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.court || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  width-130  ",
      staticStyle: {
        "flex": "none"
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.date ? _vm.dayjs(Number(item.date) * 1000).format('YYYY-MM-DD') : "--") + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  justify-center  width-80  ",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(item, 'document')
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.document_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.document_group.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.document_group.currentPage,
      "total": _vm.document_group.totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'document')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'document')
      }
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.vctbIndex == 1) ? [(_vm.detail) ? _c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.courtnotice_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.plaintiffs || "--") + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.defendants || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.type || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.court || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2  width-100  ",
      staticStyle: {
        "flex": "none"
      }
    }, [_vm._v(_vm._s(item.date || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 justify-center  width-80  ",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(item, 'courtnotice')
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.courtnotice_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.courtnotice_group.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.courtnotice_group.pagesize.currentPage,
      "total": _vm.courtnotice_group.totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'courtnotice')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'courtnotice')
      }
    }
  })], 1)], 2) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.vctbIndex == 2) ? [_vm._m(2), _vm._v(" "), _vm._l((_vm.opennotice_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.title || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.plaintiffs || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.defendants || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.releaseTime || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.court || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.hearingDate || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 justify-center  width-80",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(item, 'opennotice')
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.opennotice_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.opennotice_group.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.opennotice_group.currentPage,
      "total": _vm.opennotice_group.totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'opennotice')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'opennotice')
      }
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.vctbIndex == 3) ? [_vm._m(3), _vm._v(" "), _vm._l((_vm.filing_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(" " + _vm._s(item.caseNo || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(" " + _vm._s(item.plaintiffs || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.defendants || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.startDate || "--") + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.caseStatus || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.caseCause || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.endDate || "--"))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2 justify-center width-80",
      staticStyle: {
        "flex": "none"
      }
    }, [_c('span', {
      staticClass: "cpoint",
      staticStyle: {
        "color": "#0070c0"
      },
      on: {
        "click": function($event) {
          return _vm.showDialog(item, 'filing')
        }
      }
    }, [_vm._v("详情")])])])
  }), _vm._v(" "), (!_vm.filing_list.length) ? _c('div', {
    staticClass: "padding-bottom-40"
  }, [_c('nomore')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.filing_group.pagesize,
      "page-sizes": _vm.pageSizes,
      "hide-on-single-page": false,
      "layout": "prev, pager, next,sizes",
      "current-page": _vm.filing_group.currentPage,
      "total": _vm.filing_group.totalnum
    },
    on: {
      "size-change": function($event) {
        return _vm.handleSizeChange($event, 'filing')
      },
      "current-change": function($event) {
        return _vm.handleCurrentChange($event, 'filing')
      }
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "裁判文书详情",
      "visible": _vm.document_group.show
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.document_group, "show", $event)
      }
    }
  }, [_c('scroll-view', {
    attrs: {
      "scrollY": "",
      "height": "70vh"
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "40%",
      "background": "#F7F7F7"
    }
  }, [_vm._v("案件名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.title || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("案件类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.type || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("裁判发布日期")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.document_group.showData.date ? _vm.dayjs(Number(_vm.document_group.showData.date) * 1000).format('YYYY-MM-DD') : "--") + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("裁判文书类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.docType || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法院名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.court || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法官姓名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.judgeName || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("案件编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.caseNo || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("当事人信息")]), _vm._v(" "), _c('td', [_c('div', [_vm._v("原告:" + _vm._s(_vm.document_group.showData.plaintiffs || "--"))]), _vm._v(" "), _c('div', [_vm._v("被告:" + _vm._s(_vm.document_group.showData.defendants || "--"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("相关人/单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.parties || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("案由关键字")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.caseCause || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("正文内容")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.text || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("审批流程")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.processForSearch || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法院裁判结果")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.judgeResult || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("裁判日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.document_group.showData.date || "--"))])])])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "法院公告详情",
      "visible": _vm.courtnotice_group.show
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.courtnotice_group, "show", $event)
      }
    }
  }, [_c('scroll-view', {
    attrs: {
      "scrollY": "",
      "height": "70vh"
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "200px",
      "background": "#F7F7F7"
    }
  }, [_vm._v("当事人信息")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.courtnotice_group.showData.personInfo || "--"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法院公告类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.courtnotice_group.showData.type || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("公告人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.courtnotice_group.showData.court || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法院公告日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.courtnotice_group.showData.date || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("法院公告内容")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.courtnotice_group.showData.content || "--"))])])])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "开庭公告详情",
      "visible": _vm.opennotice_group.show
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.opennotice_group, "show", $event)
      }
    }
  }, [_c('scroll-view', {
    attrs: {
      "scrollY": "",
      "height": "70vh"
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("案件名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.title || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "200px",
      "background": "#F7F7F7"
    }
  }, [_vm._v("当事人信息")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.opennotice_group.showData.personInfo || "--"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("开庭公告发布日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.releaseTime || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("公告人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.court || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("开庭日期 (开庭公告)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.hearingDate || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("开庭法院名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.tribunal || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("关联案号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.caseNo || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("开庭公告内容")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.opennotice_group.showData.content || "--"))])])])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "开庭公告详情",
      "visible": _vm.filing_group.show
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.filing_group, "show", $event)
      }
    }
  }, [_c('scroll-view', {
    attrs: {
      "scrollY": "",
      "height": "70vh"
    }
  }, [_c('table', {
    staticClass: "pure-table pure-table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("立案案号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.caseNo || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "200px",
      "background": "#F7F7F7"
    }
  }, [_vm._v("当事人信息")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.filing_group.showData.personInfo || "--"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("相关人/单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.parties || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("立案日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.startDate || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("案件状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.caseStatus || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("立案案由")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.caseCause || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("结案时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.endDate || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {}
  }, [_vm._v("开庭日期 (立案信息)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.content || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("立案法院名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.court || "--"))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#F7F7F7"
    }
  }, [_vm._v("立案地区")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.filing_group.showData.region || "--"))])])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("案件名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("案由关键字 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("原告身份")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("被告身份")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("法院名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold   width-130  ",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("裁判发布日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center  width-80  ",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("案件详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("原告身份")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("被告身份 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("法院公告类型")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("公告人")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold width-100",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("法院公告日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center  width-80  ",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("案件详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("案件名称")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("原告身份")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("被告身份 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("开庭公告发布日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("公告人")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold "
  }, [_vm._v("开庭日期(开庭公告)")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center width-80",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("案件详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("立案案号")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("原告身份")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("被告身份 ")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("立案日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("案件状态")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("立案理由")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold"
  }, [_vm._v("结案时间")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-bold justify-center width-80",
    staticStyle: {
      "flex": "none"
    }
  }, [_vm._v("案件详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10c246ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company/components/judicial-page.vue
// module id = 880
// module chunks = 1